module.exports = __webpack_public_path__ + "img/shenhe.9db3e259.png";